import TeamView from './TeamView.vue';
export default TeamView;
